exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-outside[data-v-ec8dd4c8] {\n    width: 210px !important;\n    height: 60px;\n    cursor: pointer;\n}\n.seperator[data-v-ec8dd4c8] {\n    border-right: 2px solid #dbdbdb;\n}\n.icon-whatsapp[data-v-ec8dd4c8] {\n    font-size: 21px;\n    color: #36acbb;\n}\n.icon-phone[data-v-ec8dd4c8] {\n    height: 18px;\n}\n", ""]);

// exports
